import DataLayerService from '@shared/services/dataLayer/EecDataLayerService';

export const DataLayer = new DataLayerService();

export default DataLayer;
